import React from 'react';
import './LegendPart.css'; // Pami�taj o utworzeniu pliku CSS (kod poni�ej)
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaArrowRight } from 'react-icons/fa';

const LegendPart = ({ item }) => {
    // Destrukturyzacja danych z obiektu legendy
    const { id, image, title, subtitle, date } = item;

    return (
        <div className='list-item'>

            {/* Zdj�cie */}
            <div className='image-container'>
                <img src={image} alt={title} />
                {/* Opcjonalnie: Data na zdj�ciu lub obok */}
                <div className='date-badge'>
                    <FaCalendarAlt /> {date}
                </div>
            </div>

            {/* Tre�� */}
            <div className='content'>

                <div className='intro'>
                    {/* Tytu� linkuj�cy do szczeg��w */}
                    <Link
                        to={`/Legendy/${id}`}
                        state={item} // Przekazujemy dane do podstrony
                        className="title-link"
                    >
                        <h3>{title}</h3>
                    </Link>

                    {/* Podtytu� */}
                    <p className='subtitle'>{subtitle}</p>

                    {/* Przycisk Czytaj dalej */}
                    <Link
                        to={`/Legendy/${id}`}
                        state={item}
                        className='read-more-btn'
                    >
                        Czytaj legend� <FaArrowRight className='icon' />
                    </Link>
                </div>
            </div>

        </div>
    );
}

export default LegendPart;